/* eslint-disable no-param-reassign */

import promise from 'es6-promise';
import * as axios from 'axios';
import Cookies from 'js-cookie';
import shortId from 'js-shortid';
import nativeProxy from '@nativeApp/nativeProxy';
import { isInEnPC } from '@util/index';
import EVENTS from '@constant/events';
import eventEmitter from '@page/util/eventEmitter';
import { axiosUrlFormat } from './axiosUrlFormat';

promise.polyfill();
// axios.defaults.baseURL = '/apis';
axios.defaults.xsrfCookieName = 'csrfToken';
axios.defaults.xsrfHeaderName = 'x-csrf-token';

axios.interceptors.request.use((config) => {
  // String.prototype.includes 的兼容性操作
  if (!String.prototype.includes) {
    // eslint-disable-next-line no-extend-native
    String.prototype.includes = function (search, start) {
      if (typeof start !== 'number') {
        start = 0;
      }

      if (start + search.length > this.length) {
        return false;
      }
      return this.indexOf(search, start) !== -1;
    };
  }
  config.headers['x-auth-token'] = sessionStorage.getItem('token') || Cookies.get('token') || '';

  // 给后端统计接口来源
  if (nativeProxy && nativeProxy.isInApp()) {
    config.headers['x-source'] = 'enapp';
  }
  if (isInEnPC()) {
    config.headers['x-source'] = 'enpc';
  }
  config.url =
    config.url.indexOf('?') !== -1
      ? `${config.url}&time=${Date.now()}-${shortId.gen()}`
      : `${config.url}?time=${Date.now()}-${shortId.gen()}`;

  config.url = axiosUrlFormat(config.url);
  return config;
});

/**
 * 接口响应保护拦截
 * @param responese 响应体
 */
const responseProtectIntercept = (response) => {
  if (!response.data) {
    return;
  }

  // 状态码为 49001 ，表示触发了后端的接口保护
  if (response.data.statusCode === 49001) {
    eventEmitter.emit(EVENTS.API_PROTECT.INTERCEPT, response.data.data);
  }
};

axios.interceptors.response.use(
  (response) => {
    const code = response.status;
    if (code < 400) {
      responseProtectIntercept(response);
      return response.data;
    }
    window.alert(response.data.message ? `${response.data.message}，请到公众号反馈` : '服务异常');
    return Promise.reject(response.data);
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axios;
